import request from '@/utils/request'

export function getInventory(page_size, currentPage, branch, product) {
  return request({
    url: 'reports/getInventory/' + page_size +'/' +branch + '/' + product + '?page=' + currentPage,
    method: 'get'
  })
}

export function testD() {
  return request({
    url: 'reports/testD',
    method: 'get'
  })
}

export function dowloadInventory(data) {
  return request({
    url: 'reports/dowloadInventory',
    method: 'post',
    data,
    responseType: 'blob'
  });
}